{
  "alert": "Upozorenje",
  "dismiss": "Odbaci"
}
